// extracted by mini-css-extract-plugin
export var fadeInAnimation = "ResultModal-module--fadeInAnimation--80dc9";
export var form = "ResultModal-module--form--4b4cc";
export var hidden = "ResultModal-module--hidden--8c17f";
export var layout = "ResultModal-module--layout--9dbe6";
export var left = "ResultModal-module--left--22d99";
export var right = "ResultModal-module--right--7201b";
export var subtitle = "ResultModal-module--subtitle--e1a2e";
export var wrapper = "ResultModal-module--wrapper--b6fc4";